(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["divine-black-gold-slideshow"] && !Shopify.designMode) return;
  try {
    
const initialiseDivineSlides = () => {
  document.querySelectorAll('.divine-black-gold-slideshow').forEach(root => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const dots = [...root.querySelectorAll('[data-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const duration = Math.max(4000, Number(root.dataset.autoplayMs) || 6000);
    const go = next => {
      slides[index].classList.remove('is-active');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(() => go(index + 1), duration);
      }
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => { go(index - 1); start(); });
    root.querySelector('[data-next]')?.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach(dot => dot.addEventListener('click', () => { go(Number(dot.dataset.dot)); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseDivineSlides, { once: true });
} else {
  initialiseDivineSlides();
}
document.addEventListener('shopify:section:load', initialiseDivineSlides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
